import { SortDirection } from '@sas-dvr/ltjs-commons';
import { action } from '@sas/nova-commons/action';

const AT = {
  Sort: 'vasdk/sort/sort',
  RemoveItem: 'vasdk/sort/removeItem',
  RemoveLevel: 'vasdk/sort/removeLevel',
} as const;

export const SortActions = {
  actions: {
    sort: (id: string, data: { index: number; direction: SortDirection; isPrimary: boolean }) =>
      action(AT.Sort, { id, data }),
    removeItem: (id: string, index: number) => action(AT.RemoveItem, { id, index }),
    removeLevel: (id: string) => action(AT.RemoveLevel, { id }),
  },
  types: AT,
};
